import { gql } from '@apollo/client';

export const COMMERCIAL_VIOLATION_CONTAINERS = gql`
  query COMMERCIAL_VIOLATION_CONTAINERS($oriId: ID!){
    setupLists(oriId: $oriId) {
      commercialViolationContainers {
        id
        maxPenalty
        minPenalty
        oriId
        points
        position
        ticketViolationTypeId
        violationOccurrenceId
        waiver
        weightLimitId
      }
    }
  }
`